import React, { useState } from "react";
// --- Import components
import Logo from "../Logo/Logo";
// import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import MobileHeader from "./MobileHeader/MobileHeader";
// import AutocompleteInput from "./AutocompleteInput/AutocompleteInput";
import HelpCenter from "./HelpCenter/HelpCenter";
import HeaderSelect from "./HeaderSelect/HeaderSelect";
// --- Import Styles
import "./Header.sass";

function Header() {
  const [displayMobile, setDisplayMobile] = useState(false);

  function closeMobileHeader() {
    setDisplayMobile(false);
  }

  // const breakPoint = window.matchMedia(`(max-width:992px)`).matches;

  return displayMobile ? (
    <MobileHeader closeMobileHeader={() => closeMobileHeader()} />
  ) : (
    <header className="header">
      <div className="container">
        <section className="row justify-content-between align-items-center">
          <section className="col-auto  pr-0 header__cell">
            <div className="row align-items-center">
              {/* {breakPoint && (
                <div className="col-auto">
                  <button
                    aria-label="burger"
                    className="select-burger"
                    onClick={() => setDisplayMobile(!displayMobile)}
                  >
                    <span />
                    <span />
                    <span />
                  </button>
                </div>
              )} */}
              <div className="col-auto">
                <Logo />
              </div>
            </div>
          </section>
          <section className="col-auto header__cell  header__cell--end">
            {/* {!breakPoint && (
              <ErrorBoundary>
                <AutocompleteInput
                  controler="accountStore"
                  action="menuSearch"
                />
              </ErrorBoundary>
            )} */}
            <HelpCenter />
            <HeaderSelect />
          </section>
        </section>
      </div>
    </header>
  );
}

Header.propTypes = {};

export default Header;
